import { openLeadform } from './elements/leadForm';
import addStartupScript from './events/addStartupScript';
import addTargetEventListener from './events/addTargetEventListener';
import dispatchCustomEvent from './events/dispatchCustomEvent';
import getVisitorId from './storage/getVisitorId';

const documentModalOpenedClass = 'html--modal-open';
const documentModalClosedClass = 'html--modal-closed';
const modalOpenedClass = 'modal--open';
const modalClosedClass = 'modal--closed';

export function openModal(modal = document.querySelector('.modal')) {
  if (modal) {
    modal.classList.add(modalOpenedClass);
    modal.classList.remove(modalClosedClass);
  }
  document.documentElement.classList.remove(documentModalClosedClass);
  document.documentElement.classList.add(documentModalOpenedClass);
}

export function closeModal(event) {
  const classList = event.target.classList;
  if (classList.contains('modal') || classList.contains('js-modal-close')) {
    document.documentElement.classList.remove(documentModalOpenedClass);
    document.documentElement.classList.add(documentModalClosedClass);

    const modal = event.target.closest(`.${modalOpenedClass}`);
    if(modal) {
      dispatchCustomEvent(modal, 'closeModal');
      modal.classList.remove(modalOpenedClass);
      modal.classList.add(modalClosedClass);
    }
  }
}

export function handleModalTriggerClick(event) {
  const modal = document.querySelector('.modal');
  const trigger = event.target;
  // Special functionality for social sharing
  // If the modal trigger is a course_list_card share link:
  // Attach 'course_list_card' "data-share-url" and "data-course-name" as properties of 'modal'
  // This allows FB/twitter/email buttons to read these values on their *future* clicks
  if (trigger.dataset.shareUrl && trigger.dataset.shareCourseName) {
    modal.shareUrl = trigger.dataset.shareUrl;
    modal.shareCourseName = trigger.dataset.shareCourseName;
  } else {
    // If the modal trigger is not a `course_list_card`:
    // Use the current page url as the shareUrl
    modal.shareUrl = window.location.href.split('?')[0];
    modal.shareCourseName = undefined;
  }

  // If there is a 'social' component inside the modal,
  // pre-fill the copy-to-clipboard url at this point
  const urlCopyBoxes = document.querySelectorAll('.js-social-copy-url');
  const visitorId = getVisitorId();

  if (urlCopyBoxes.length > 0) {
    Array.from(urlCopyBoxes).forEach((box) => {
      box.value = modal.shareUrl + '?direct_share=copy&v_id=' + visitorId;
    });
  }

  openModal();

  const leadform = modal.querySelector('.leadform');
  if (leadform) openLeadform(leadform);
}

export function modalTimeout() {
  // If modal contains the param "timer: X" the modal will open after X seconds
  // 0 means modal opens on page load
  const timer = document.querySelector('.modal--timer');

  if (timer) {
    const timerLength = parseInt(timer.dataset.timeout) * 1000;
    setTimeout(openModal, timerLength);
  }
}

addStartupScript(modalTimeout);
addTargetEventListener('click', '.js-modal-trigger', handleModalTriggerClick);
addTargetEventListener('click', '.js-modal-close', closeModal);
addTargetEventListener('click', '.modal', closeModal);
